/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_First_Number_HintInputs */



/**
* | output |
* | --- |
* | "The first table number must be 1 or more. Not saved until fixed." |
*
* @param {Rooms_First_Number_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_first_number_hint = /** @type {((inputs?: Rooms_First_Number_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_First_Number_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le premier numéro de table doit être 1 ou plus. Non enregistré tant que ce n'est pas corrigé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El primer número de mesa debe ser 1 o más. No se guarda hasta corregirlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O primeiro número de mesa precisa ser 1 ou mais. Não é salvo até corrigir.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il primo numero di tavolo deve essere 1 o più. Non salvato finché non è corretto.")
	return /** @type {LocalizedString} */ ("The first table number must be 1 or more. Not saved until fixed.")
});